import React from 'react';
import styles from './index.module.scss';
import type { DividerTimeProps } from './type';

const DividerTime: React.FC<DividerTimeProps> = (props) => {
  return <div className={styles.dividerTime}>{props.children} </div>;
};

export default DividerTime;
